﻿import { PhpYesNoUnknown, RccapPhase, RccapCorrectiveAction } from '../../enums/index';
import { IRccapAdditionalQuestion } from './rccap-additional-question';

export interface IRccap {
    id: number;
    currentStatusId: number;
    currentStatusDescription: string;
    responsibleCenterId: number;
    responsibleCenterName: string;
    responsibleCenterAlias: string;
    recipientCenterId: number;
    recipientCenterName: string;
    recipientCenterAlias: string;
    recipientId: number;
    recipientAlias: string;
    recipientPmpc: string;
    recipientCpra: string;
    recipientAbo: string;
    recipientsDonorAbo: string;
    matchOfferDate: string;
    exmRequestDate: string;
    failDate: string;
    targetSurgeryDate: string;
    dueDate: string;
    responseDate: string;
    daysTillSurgery: number;
    timeline: Map<string, string>[];
    monthsWaiting: number;
    donorCenterId: number;
    donorCenterName: string;
    donorCenterAlias: string;
    donorId: number;
    donorAlias: string;
    rccapManagerId: number;
    rccapManager: string;
    rccapRequesterId: number;
    rccapRequester: string;
    swapChainNumber: number;
    swapClusterNumber: number;
    swapPositionNumber: number;
    transplantsImpacted: number;
    surgeriesImpacted: number;
    whatHappened: string;
    originalAdditionalQuestions: string;
    additionalQuestions: IRccapAdditionalQuestion[];
    rootCausePrimaryId: number;
    rootCausePrimary: string;
    rootCauseSecondaryId: number;
    rootCauseSecondary: string;
    rootCauseInfo: string;
    rootCauseAdditional: string;
    avoidable: PhpYesNoUnknown;
    avoidableDescription: string;
    billable: PhpYesNoUnknown;
    billableDescription: string;
    phase: RccapPhase;
    phaseDescription: string;
    correctiveActionPrimary: RccapCorrectiveAction;
    correctiveActionPrimaryDescription: string;
    correctiveActionSecondary: RccapCorrectiveAction;
    correctiveActionSecondaryDescription: string;
    correctiveActionInfo: string;
    correctiveActionAdditional: string;
    responder: string;
    shortAdminCorrectiveAction: string;
    shortAdminRootCause: string;
    additionalComments: string;
    satisfactoryResponse: number;
    daysLate: number;
}
